import React, { useEffect, useState } from 'react';
import { t } from '../../../global-components/src/i18nTranslate';
import "./style.css"
import axios from 'axios';
import { PACOCA_API_URL, PACOCA_URL } from '../../../global-components/src/utils/vars';
import { useAuth, useMessage, useTheme } from '../../../global-components/src';
import { DailyStreak } from '../../../global-components/src/types';
import Spinner from '../../../global-components/src/components/spinner/spiner';
import { errorMessage, formatBalance } from '../../../global-components/src/utils/text';
import CoinDrop from '../../coin-drop/coin-drop';
import { useNavigate } from 'react-router-dom';
import { Link2 } from 'react-feather';
import { Icon } from '../../../global-components/src/components/icon';

const BranTokensWalletContent = () => {
    const { user, token, isAuthenticated } = useAuth();
    const { isDarkMode } = useTheme();
    const { setMessage } = useMessage();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [loadingRescue, setLoadingRescue] = useState(false);
    const [loadingReward, setLoadingReward] = useState(false);
    const [socialRewards, setSocialRewards] = useState<string[]>(() => {
        const saved = localStorage.getItem("socialRewards");
        return saved ? JSON.parse(saved) : [];
    });
    const [lastPost, setLastPost] = useState<string>(() => {
        const saved = localStorage.getItem("lastPost");
        return saved ? saved : "";
    });
    const [totalWatched, setTotalWatched] = useState<number>(() => {
        const saved = localStorage.getItem("totalWatched");
        return saved ? Number(saved) : 0;
    });
    const [balance, setBalance] = useState<number>(() => {
        const saved = localStorage.getItem("branTokensWalletBalance");
        return saved ? Number(saved) : 0;
    });
    const [showCoins, setShowCoins] = useState(false);
    const [dailyStreak, setDailyStreak] = useState<DailyStreak | null>(() => {
        const saved = localStorage.getItem("dailyStreak");
        return saved ? JSON.parse(saved) : null;
    });
    const [waitingVideo, setWaitingVideo] = useState(false);
    const VIDEO_LINKS = [
        "https://youtu.be/peTiJnWZfgQ?si=rxoD-BmUDyV34n96",
        "https://www.youtube.com/@Pa%C3%A7oca_rede",
        "https://www.tiktok.com/@paoca.rede.social/photo/7583363940424486162",
        "https://www.tiktok.com/@paoca.rede.social/video/7531911337442577720",
        "https://www.youtube.com/watch?v=ZncQI3EHL68",
        "https://www.instagram.com/pacoca.rede",
        "https://www.tiktok.com/@paoca.rede.social",
        "https://www.instagram.com/p/DSAbWVogOLZ/",
        "https://www.youtube.com/watch?v=ZncQI3EHL68",
        "https://www.facebook.com/profile.php?id=61564992938493",
    ];
    const [timeLeft, setTimeLeft] = useState("");

    useEffect(() => {
        if (!lastPost) return;

        const interval = setInterval(() => {
            const postDate = new Date(lastPost).getTime();
            const endTime = postDate + 24 * 60 * 60 * 1000;
            const now = new Date().getTime();

            const diff = endTime - now;

            if (diff <= 0) {
                setTimeLeft("Disponível");
                clearInterval(interval);
                return;
            }

            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            setTimeLeft(
                `${hours.toString().padStart(2, "0")}:${minutes
                    .toString()
                    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
            );
        }, 1000);

        return () => clearInterval(interval);
    }, [lastPost]);

    const watchRandomVideo = () => {
        if(!isAuthenticated){
            navigate("/login");
            return;
        }

        if (waitingVideo || totalWatched >= VIDEO_LINKS.length) return;
        setLoadingReward(true);
        // escolhe aleatório
        const randomLink = VIDEO_LINKS[Math.floor(Math.random() * VIDEO_LINKS.length)];

        // abre nova aba
        window.open(randomLink, "_blank");

        // trava botão
        setWaitingVideo(true);
        setMessage("Assistindo vídeo... aguarde alguns segundos", "warning");

        // tempo mínimo assistindo (ex: 5s)
        setTimeout(async () => {
            setWaitingVideo(false);
            await reward();
        }, 5000);
    };

    const socialReward = async (type: "instagram" | "youtube"  | "joao" | "bochecha") => {
        if (socialRewards.includes(type)) {
            setMessage("Recompensa já resgatada", "warning");
            return;
        }

        try {
            const response = await axios.post(`${PACOCA_API_URL}/bran-token/social-reward`,
            { type },
            { headers: { Authorization: `Bearer ${token}` } }
            );

            const updated = [...socialRewards, type];
            setSocialRewards(updated);
            setBalance(Number(response.data.balance));
            
            localStorage.setItem("branTokensWalletBalance", response.data.balance);
            localStorage.setItem("socialRewards", JSON.stringify(updated));

            setMessage("Recompensa recebida!", "success");
            setShowCoins(true);

        } catch (err:any) {
            setMessage(errorMessage(err), "error");
        }
    };

    const loadData = async() => {
        setLoading(true);
        if(!isAuthenticated) return;

        try {
            const response = await axios.get(`${PACOCA_API_URL}/bran-token`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setBalance(Number(response.data.balance));
            setDailyStreak(response.data.daily_streak);
            setTotalWatched(response.data.watched);
            setSocialRewards(response.data.social_rewards || []);
            setLastPost(response.data.last_post_created_at || "");

            localStorage.setItem("branTokensWalletBalance", response.data.balance);
            localStorage.setItem("dailyStreak", JSON.stringify(response.data.daily_streak));
            localStorage.setItem("lastPost", response.data.last_post_created_at || "");
        } catch (err: any) {
            setMessage(err?.response?.data?.message || "Erro ao carregar carteira", "error");
        } finally {
            setLoading(false);
        } 
    }

    function isToday(date?: Date) {
        const today = new Date();
        if(!date) return false;

        return (
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate()
        );
        }

    const rescue = async() => {
        setLoadingRescue(true);
        if(!isAuthenticated){
            navigate("/login");
            return;
        }
        
        try {
            const response = await axios.post(`${PACOCA_API_URL}/bran-token/rescue`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setBalance(Number(response.data.balance));
            setDailyStreak(response.data.daily_streak);
            
            localStorage.setItem("branTokensWalletBalance", response.data.balance);
            localStorage.setItem("dailyStreak", JSON.stringify(response.data.daily_streak));
            localStorage.setItem("totalWatched", response.data.watched);
            setMessage("Resgate realizado com sucesso!", "success");
            setShowCoins(true);
        } catch (err: any) {
            const message = errorMessage(err);
            setMessage(message, "error");
            console.error(err);
        } finally {
            setLoadingRescue(false);
        } 
    }

    const reward = async() => {
        try {
            const response = await axios.post(`${PACOCA_API_URL}/bran-token/reward`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTotalWatched(response.data.watched);
            setBalance(Number(response.data.balance));
            
            localStorage.setItem("branTokensWalletBalance", response.data.balance);
            localStorage.setItem("totalWatched", response.data.watched);
            setMessage("Resgate realizado com sucesso!", "success");
            setShowCoins(true);
        } catch (err: any) {
            const message = errorMessage(err);
            setMessage(message, "error");
            console.error(err);
        } finally {
            setLoadingReward(false);
        } 
    }
    
    useEffect(() => {
        loadData();
    }, []);

    
    const copyReferralCode = () => {
        if (navigator.clipboard && navigator.clipboard.writeText && user?.referral_code) {
            navigator.clipboard.writeText(`${PACOCA_URL}/cadastro?referral_code=${user.referral_code}`)
                .then(() => setMessage("Envie para seus amigos! É necessário verificar o email", "success", "Link copiado"))
                .catch((error) => console.error('Erro ao copiar o link:', error));
        }
    }

    useEffect(() => {
        if (!showCoins) return;

        const timer = setTimeout(() => {
            setShowCoins(false);
        }, 2000); // tempo da animação

        return () => clearTimeout(timer);
    }, [showCoins]);
    

    return (
        <>
            {showCoins && <CoinDrop count={10} />}

           <div className="bran-content">
                <div className="value-bran">
                    <div className="col">
                        <div className='d-flex align-items-center'>
                            <p className='bran'>{t("branToken.bran")}</p>
                            <img className='bran-token-img-value' src="/img/token.png" alt="" />
                        </div>
                        <p className='bran-value'>{formatBalance(balance)}</p>
                    </div>

                    <div className="col col-invite">
                    </div>
                </div>

                <div className='img-invite'>
                    <img className='img-invite' src="/img/invite.png" alt=""/>
                    <button className='btn btn-invite' onClick={copyReferralCode}>
                        <span style={{ marginRight: 5 }}>
                            {t("branToken.invite")}
                        </span>
                        <Icon color='#fff' style={{ marginTop: 5 }} invertColor={!isDarkMode} name="link_2" size={20}/>
                    </button>
                </div>

                <div className='img-invite'>
                    <img className='img-invite' src="/img/win-tokens.png" alt=""/>
                    <div className="timer">{timeLeft}</div>
                </div>

                <div className="div-enter">
                    <div className="col first-col-div-enter">
                        <h5 className='watchAndWin'>
                            {t("branToken.watchAndWin")} <span className="points">{t("branToken.pointsToWatch")}</span>
                        </h5>
                    </div>
                    <div className="col second-col-div-enter">
                        <button disabled={loadingReward || totalWatched >= VIDEO_LINKS.length} className='btn btn-bran btn-primary' onClick={watchRandomVideo}>
                            {loadingReward && <Spinner className='mr-2' size='15px'/>}
                            {!loadingReward && ( <>{t("branToken.watch")} {totalWatched}/{VIDEO_LINKS.length}</> )}
                        </button>
                    </div>
                </div>

                {!socialRewards.includes("instagram") || !socialRewards.includes("youtube") ? (
                    <>
                        <div className="div-enter">
                            <div className="col first-col-div-enter">
                                <h5 className='watchAndWin'>
                                    {t("branToken.followInsta")} <span className="points">{t("branToken.pointsToWatch")}</span>
                                </h5>
                            </div>
                            <div className="col second-col-div-enter">
                                <button disabled={socialRewards.includes("instagram")} className='btn btn-bran btn-primary' onClick={() => { window.open("https://www.instagram.com/pacoca.rede", "_blank"); setTimeout(() => socialReward("instagram"), 3000); }}>
                                    {socialRewards.includes("instagram") ? t("branToken.rescued") : t("user.follow.follow")}
                                </button>
                            </div>
                        </div>

                        <div className="div-enter">
                            <div className="col first-col-div-enter">
                                <h5 className='watchAndWin'>
                                    {t("branToken.followYoutube")} <span className="points">{t("branToken.pointsToWatch")}</span>
                                </h5>
                            </div>
                            <div className="col second-col-div-enter">
                                <button disabled={socialRewards.includes("youtube")} className='btn btn-bran btn-primary' onClick={() => { window.open("https://www.youtube.com/@Paçoca_rede", "_blank"); setTimeout(() => socialReward("youtube"), 3000); }}>
                                    {socialRewards.includes("youtube") ? t("branToken.rescued") : t("user.follow.follow")}
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="div-enter">
                            <div className="col first-col-div-enter">
                                <h5 className='watchAndWin'>
                                    {t("branToken.follow", { user: "João" })} <span className="points">{t("branToken.pointsToWatch")}</span>
                                </h5>
                            </div>
                            <div className="col second-col-div-enter">
                                <button disabled={socialRewards.includes("joao")} className='btn btn-bran btn-primary' onClick={() => { window.open("https://www.instagram.com/joaoenrique1308?igsh=MmU2cnhuaW5lNGRm", "_blank"); setTimeout(() => socialReward("joao"), 3000); }}>
                                    {socialRewards.includes("joao") ? t("branToken.rescued") : t("user.follow.follow")}
                                </button>
                            </div>
                        </div>

                        <div className="div-enter">
                            <div className="col first-col-div-enter">
                                <h5 className='watchAndWin'>
                                    {t("branToken.follow", { user: "Gabriel" })} <span className="points">{t("branToken.pointsToWatch")}</span>
                                </h5>
                            </div>
                            <div className="col second-col-div-enter">
                                <button disabled={socialRewards.includes("bochecha")} className='btn btn-bran btn-primary' onClick={() => { window.open("https://www.instagram.com/loureiro.427?igsh=OHV6Z3R1YTJvcm4w", "_blank"); setTimeout(() => socialReward("bochecha"), 3000); }}>
                                    {socialRewards.includes("bochecha") ? t("branToken.rescued") : t("user.follow.follow")}
                                </button>
                            </div>
                        </div>
                    </>
                ) }

                <div className="div-enter">
                    <h5 className='watchAndWin'>
                        {t("branToken.enter")} <span className="points">{t("branToken.points")}</span>
                    </h5>
                </div>

                <p className="text-center enter-description"> {t("branToken.enterDescription")}</p>  
           </div>


            <div className='bran-token-container user-select-none'>
                <div className='bran-token-item'>
                    <div className={`bran-token-up ${dailyStreak?.current_day == 0 ? 'bran-token-select' : ''}`}>
                        <img className='bran-token-img' src="/img/token.png" alt="" />
                        <h5>1.000</h5>
                    </div>
                    <div className='bran-token-down'>
                        <h5>{t("generics.day")} 1</h5>
                    </div>
                </div>
                <div className='bran-token-item'>
                    <div className={`bran-token-up ${dailyStreak?.current_day == 1 ? 'bran-token-select' : ''}`}>
                        <img className='bran-token-img' src="/img/token.png" alt="" />
                        <h5>1.500</h5>
                    </div>
                    <div className='bran-token-down'>
                        <h5>{t("generics.day")} 2</h5>
                    </div>
                </div>
                <div className='bran-token-item'>
                    <div className={`bran-token-up ${dailyStreak?.current_day == 2 ? 'bran-token-select' : ''}`}>
                        <img className='bran-token-img' src="/img/token.png" alt="" />
                        <h5>2.000</h5>
                    </div>
                    <div className='bran-token-down'>
                        <h5>{t("generics.day")} 3</h5>
                    </div>
                </div>
                <div className='bran-token-item'>
                    <div className={`bran-token-up ${dailyStreak?.current_day == 3 ? 'bran-token-select' : ''}`}>
                        <img className='bran-token-img' src="/img/token.png" alt="" />
                        <h5>2.500</h5>
                    </div>
                    <div className='bran-token-down'>
                        <h5>{t("generics.day")} 4</h5>
                    </div>
                </div>
                <div className='bran-token-item'>
                    <div className={`bran-token-up ${dailyStreak?.current_day == 4 ? 'bran-token-select' : ''}`}>
                        <img className='bran-token-img' src="/img/token.png" alt="" />
                        <h5>3.500</h5>
                    </div>
                    <div className='bran-token-down'>
                        <h5>{t("generics.day")} 5</h5>
                    </div>
                </div>
                <div className='bran-token-item'>
                    <div className={`bran-token-up ${dailyStreak?.current_day == 5 ? 'bran-token-select' : ''}`}>
                        <img className='bran-token-img' src="/img/token.png" alt="" />
                        <h5>4.500</h5>
                    </div>
                    <div className='bran-token-down'>
                        <h5>{t("generics.day")} 6</h5>
                    </div>
                </div>
                <div className='bran-token-item'>
                    <div className={`bran-token-up ${dailyStreak?.current_day == 6 && isToday(dailyStreak?.last_claimed_at ? new Date(dailyStreak?.last_claimed_at) : undefined) ? 'bran-token-select' : ''}`}>
                        <img className='bran-token-img' src="/img/token.png" alt="" />
                        <h5>5.000</h5>
                    </div>
                    <div className='bran-token-down'>
                        <h5>{t("generics.day")} 7</h5>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center div-btn-daily">
                <button disabled={loadingRescue || isToday(dailyStreak?.last_claimed_at ? new Date(dailyStreak?.last_claimed_at) : undefined)} className='btn btn-bran btn-primary' onClick={rescue}>
                    {loadingRescue && <Spinner className='mr-2' size='15px'/>}
                    {t("branToken.rescue")}
                </button>
            </div>
            
        </>
    );
};

export default BranTokensWalletContent;